(() => {
  const PROFILE_KEY = 'quiz_profile';
  const PROFILE_NAME_KEY = 'quiz_profile_name';
  const SAMPLE_ID = window.QUIZ_SAMPLE_VARIANT_ID;
  const QUIZ_IDS = new Set((window.QUIZ_PRODUCT_IDS || []).map(Number));

  let busy = false;

  const getProfile = () => localStorage.getItem(PROFILE_KEY);
  const getProfileName = () => localStorage.getItem(PROFILE_NAME_KEY) || localStorage.getItem(PROFILE_KEY);

  const setProfile = (code, name) => {
    if (code) localStorage.setItem(PROFILE_KEY, code);
    if (name) localStorage.setItem(PROFILE_NAME_KEY, name);
    else if (code) localStorage.setItem(PROFILE_NAME_KEY, code);
  };

  const clearProfile = () => {
    localStorage.removeItem(PROFILE_KEY);
    localStorage.removeItem(PROFILE_NAME_KEY);
  };

  const extractProfileCode = answers => {
    if (!answers) return null;
    const key = Object.keys(answers).find(
      k => /quiz results/i.test(k) && /^P\d+$/i.test(answers[k])
    );
    return key ? answers[key] : null;
  };

  const extractProfileName = detail => {
    const sections = detail && detail.sections;
    if (!Array.isArray(sections)) return null;
    for (const sec of sections) {
      const blocks = (sec && sec.top_content) || [];
      const heading = blocks.find(
        b => b && b.text_type === 'heading' && typeof b.text === 'string' && b.text.trim()
      );
      if (heading) return heading.text.trim();
    }
    return null;
  };

  const getCart = async () => (await fetch('/cart.js')).json();

  const hasQuizProduct = cart =>
    cart.items.some(i => QUIZ_IDS.has(Number(i.product_id)) && Number(i.variant_id) !== Number(SAMPLE_ID));

  const findSample = cart =>
    cart.items.find(i => Number(i.variant_id) === Number(SAMPLE_ID));

  const addSample = async profileName => {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: SAMPLE_ID, quantity: 1, properties: { _quiz_profile: profileName } }] })
    });
  };

  const removeSample = async sample => {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: sample.key, quantity: 0 })
    });
  };

  const setAttribute = async profileName => {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'Skin Profile': profileName } })
    });
  };

  const clearAttribute = async () => {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'Skin Profile': '' } })
    });
  };

  const paintDrawer = async () => {
    try {
      const res = await fetch('/?section_id=cart-drawer');
      const html = await res.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const newBody = parsed.querySelector('#CartDrawer-Body');
      const curBody = document.querySelector('#CartDrawer-Body');
      if (newBody && curBody) curBody.innerHTML = newBody.innerHTML;
      if (typeof window.updateCartCounters === 'function') window.updateCartCounters();
    } catch (e) {
      console.error('quiz-sample drawer refresh failed', e);
    }
  };

  const paintCartPage = async cartItemsEl => {
    try {
      const sectionId = cartItemsEl.id;
      const res = await fetch(`/cart?section_id=${encodeURIComponent(sectionId)}`);
      const html = await res.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const newEl = parsed.querySelector(`#${CSS.escape(sectionId)}`) || parsed.querySelector('cart-items');
      if (newEl) cartItemsEl.innerHTML = newEl.innerHTML;
      if (typeof window.updateCartCounters === 'function') window.updateCartCounters();
    } catch (e) {
      console.error('quiz-sample cart page refresh failed', e);
    }
  };

  const refreshCartUI = async () => {
    const cartItemsEl = document.querySelector('cart-items');
    if (cartItemsEl) {
      await paintCartPage(cartItemsEl);
      setTimeout(() => paintCartPage(cartItemsEl), 250);
    } else {
      await paintDrawer();
      setTimeout(paintDrawer, 250);
    }
  };

  const reconcile = async () => {
    if (busy || !SAMPLE_ID) return;
    busy = true;
    let changed = false;
    try {
      const cart = await getCart();
      const profile = getProfile();
      const profileName = getProfileName();
      const sample = findSample(cart);
      const qualifies = hasQuizProduct(cart) && !!profile;

      if (qualifies && !sample) {
        await addSample(profileName);
        await setAttribute(profileName);
        changed = true;
      } else if (!qualifies && sample) {
        await removeSample(sample);
        await clearAttribute();
        if (!hasQuizProduct(cart)) clearProfile();
        changed = true;
      } else if (qualifies && sample) {
        const isLast = cart.items[cart.items.length - 1].key === sample.key;
        if (!isLast) {
          await removeSample(sample);
          await addSample(profileName);
          changed = true;
        }
        if (sample.properties?._quiz_profile !== profileName) {
          await setAttribute(profileName);
        }
      }
    } catch (e) {
      console.error('quiz-sample reconcile failed', e);
    } finally {
      busy = false;
      if (changed) await refreshCartUI();
    }
  };

  document.addEventListener('octane.quiz.completed', e => {
    const detail = e.detail || {};
    const code = extractProfileCode(detail.answers);
    const name = extractProfileName(detail);
    if (code || name) setProfile(code, name);
  });

  window.quizSampleReconcile = reconcile;

  const origFetch = window.fetch;
  window.fetch = function (input) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const isCartWrite = /\/cart\/(add|change|update|clear)/.test(url) && !/section_id/.test(url);
    const p = origFetch.apply(this, arguments);
    if (isCartWrite && !busy) {
      p.then(() => setTimeout(reconcile, 50)).catch(() => {});
    }
    return p;
  };

  const OrigXHR = window.XMLHttpRequest;
  if (OrigXHR) {
    const origOpen = OrigXHR.prototype.open;
    const origSend = OrigXHR.prototype.send;
    OrigXHR.prototype.open = function (method, url) {
      this._quizUrl = url || '';
      return origOpen.apply(this, arguments);
    };
    OrigXHR.prototype.send = function () {
      const url = this._quizUrl || '';
      const isCartWrite = /\/cart\/(add|change|update|clear)/.test(url) && !/section_id/.test(url);
      if (isCartWrite) {
        this.addEventListener('loadend', () => {
          if (!busy) setTimeout(reconcile, 50);
        });
      }
      return origSend.apply(this, arguments);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reconcile);
  } else {
    reconcile();
  }
})();